import { Progress } from '@sortlist-frontend/design-system';

interface BarTrackProps {
  label: string;
  ratio: number;
  isMuted?: boolean;
}

export const BarTrack = (props: BarTrackProps) => {
  const { label, ratio, isMuted = false } = props;

  return (
    <Progress
      aria-label={label}
      value={Math.max(3, Math.min(100, ratio * 100))}
      size="md"
      radius="full"
      color={isMuted ? 'secondary' : 'primary'}
      classNames={{ track: 'bg-secondary-100', base: 'gap-0' }}
    />
  );
};
